import { render, staticRenderFns } from "./BomCar.vue?vue&type=template&id=744ca630&"
import script from "./BomCar.vue?vue&type=script&lang=js&"
export * from "./BomCar.vue?vue&type=script&lang=js&"
import style0 from "./BomCar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports